import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// styled
import { StyledUpload } from "./StyledUpload";

// components
import TopBar from "components/TopBar/TopBar";
import LoadingBar from "components/LoadingBar/LoadingBar";
import ModalPopup from "components/ModalPopup/ModalPopup";

// api
import { getProject } from "api/getProject/getProject.api";
import { getMaterialLib } from "api/getMaterialLib/getMaterialLib.api";
import { modelUpload } from "api/modelUpload/modelUpload.api";
import { deleteProject } from "api/deleteProject/deleteProject.api";
import { deleteModel } from "api/deleteModel/deleteModel.api";
import { reviseProject } from "api/reviseProject/reviseProject.api";
import { useMaterialLib } from "api/useMaterialLib/useMaterialLib.api";
import { projectPicture } from "api/projectPicture/projectPicture.api";
import { updateModel } from "api/updateModel/updateModel.api";

// hooks
import useModal from "hooks/useModal";

// config
import { modalConfig } from "config/modal";

// plugin
import Dropzone from "react-dropzone";
import "@google/model-viewer/dist/model-viewer";
import Cookies from "js-cookie";

// images
import fileUploadIcon from "./images/fileUploadIcon.svg";
import closeIcon from "./images/closeIcon.png";

// i18n
import { useTranslation } from "react-i18next";

// react bootstrap
import ProgressBar from "react-bootstrap/ProgressBar";

// constants
import SERVER from "constants/server";
import ThreeJs from "../../components/ThreeJs/ThreeJs";

// utils
import { prepareModelFile, isGltfOrZipUpload } from "utils/gltfUpload";

// 只給下方 acceptedFiles 後段的「單檔備援路徑」用；Dropzone 本身沒設 accept，
// glTF / ZIP 在前段就由 isGltfOrZipUpload 分流、不經過這個清單，所以不需要加 zip
const ACCEPTED_FILE_TYPES = ["glb", "gltf", "ksplat", "splat"]; //ksplat needs to come before splat
const MAX_UPLOAD_MB = 100;
/** 進度條分段：bytes 送完 70%，之後依序是後端處理、載入模型、截圖、上傳縮圖 */
const UPLOAD_BAR_SENT = 70;
const UPLOAD_BAR_UPLOADED = 78;
const UPLOAD_BAR_LOADING = 82;
const UPLOAD_BAR_RENDERED = 92;
const UPLOAD_BAR_THUMB = 95;
const UPLOAD_BAR_DONE = 99;
const MAX_FILE_NAME_LENGTH = 80;

/** 打包失敗時依錯誤 code 決定 modal：超過容量 → 既有的容量提示；zip 檔數過多 → 格式錯誤；其餘 → 缺 .bin / 貼圖 */
const PACK_ERROR_MODAL = { OVER_SIZE: "type14", TOO_MANY_ENTRIES: "type16" };

const Upload = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const getFileName = urlParams.get("fileName");
  const getuseMaterialLab = urlParams.get("useMaterialLab");

  const { t } = useTranslation();
  const navigate = useNavigate();
  const modelViewer = useRef();
  const tootipbox = useRef();
  // glTF / ZIP 打包是非同步的：記住最後一次選檔的序號，舊的打包結果晚到就丟掉，不覆蓋新選的檔案
  const packRequestId = useRef(0);
  const { modalSetting, setModalSetting } = useModal();

  const [isUpload, setIsUpload] = useState(false);
  const [startUpload, setStartUpload] = useState(false);
  const [loaderThreeJs, setLoaderThreeJs] = useState(false);
  const [fileModel, setFlieModel] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [otherModelTitle, setOtherTitle] = useState(false);
  const [UploadOption, setUploadOption] = useState(true);
  const [UploadProgress, setUploadProgress] = useState(0);
  const [materialLib, setMaterialLib] = useState([]);
  const [openIframe, setOpenIframe] = useState(false);
  const [materialIframe, setMaterialIframe] = useState(null);
  // model loading progress bar
  const [modelLoadingProgress, setModelLoadingProgress] = useState(0);
  const [showModelErr, setShowModelErr] = useState(false);
  const [openMaterialPicHolder, setOpenMaterialPicHolder] = useState(false);
  const [openNameTootip, setOpenNameTootip] = useState(false);
  const [nameTootip, setNameTootip] = useState("");
  const [threeThumbnail, setThreeThumbnail] = useState("");

  const handleErrorResponse = (modalType) => {
    setModalSetting({
      ...modalSetting,
      show: true,
      title: "",
      coverSetting: true,
      otherBtnText: t("PleaseTryAgain"),
      noClose: true,
      type: modalType,
      handleConfirm: () => {},
    });
  };

  useEffect(() => {
    if (getuseMaterialLab) {
      setUploadOption(false);
    }
    if (
      urlParams.get("projectId") &&
      urlParams.get("modelId") &&
      urlParams.get("token") &&
      urlParams.get("isPublish")
    ) {
      Cookies.set("projectId", decodeURIComponent(urlParams.get("projectId")));
      Cookies.set("modelId", decodeURIComponent(urlParams.get("modelId")));
      Cookies.set("token", decodeURIComponent(urlParams.get("token")));
      Cookies.set("isPublish", decodeURIComponent(urlParams.get("isPublish")));
      setOtherTitle(true);
    } else {
      getProject(Cookies.get("token"), Cookies.get("projectId")).then((res) => {
        Cookies.set("modelId", res.project.editors[0].models[0].id);
      });
    }
    // 處理初始素材庫載入
    setOpenMaterialPicHolder(true);
    let getMoreList = true;
    let page = 0;
    let size = 12;
    getMaterialLib(size, page)
      .then((res) => {
        page++;
        if (res.content.length < size) {
          getMoreList = false;
        }
        setMaterialLib(res.content);
        setOpenMaterialPicHolder(false);
      })
      .catch((err) => {
        setModalSetting({
          ...modalSetting,
          show: true,
          title: "",
          coverSetting: true,
          otherBtnText: t("PleaseTryAgain"),
          noClose: true,
          type: "type22",
          handleConfirm: () => {},
        });
      });
    const handleScroll = () => {
      let cHeight = document.documentElement.clientHeight;
      let sHeight = document.documentElement.scrollHeight;
      let sTop = document.documentElement.scrollTop;
      if (sHeight == Math.round(cHeight + sTop)) {
        if (getMoreList) {
          setOpenMaterialPicHolder(true);
          getMaterialLib(size, page)
            .then((res) => {
              page++;
              if (res.content.length < size) {
                getMoreList = false;
              }
              setMaterialLib((prevState) => {
                return [...prevState, ...res.content];
              });
              setOpenMaterialPicHolder(false);
            })
            .catch((err) => {
              setModalSetting({
                ...modalSetting,
                show: true,
                title: "",
                coverSetting: true,
                otherBtnText: t("PleaseTryAgain"),
                noClose: true,
                type: "type22",
                handleConfirm: () => {},
              });
            });
        }
      }
      let uploadOption = document.querySelector(".uploadOption");
      if (sTop > 20) {
        uploadOption.classList.add("leaveTop");
      } else if (sTop < 20) {
        uploadOption.classList.remove("leaveTop");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // modelviewer
    const getModelViewer = document.querySelector("#myModelViewer");
    getModelViewer.addEventListener("error", (e) => {
      setModalSetting({
        ...modalSetting,
        coverSetting: true,
        otherBtnText: t("PleaseTryAgain"),
        noClose: true,
        handleOtherAction: true,
        iframe: true,
        type: "type37",
        handleConfirm: () => {
          window.location.reload();
        },
      });
      setShowModelErr(true);
    });
    const netStatus = navigator.onLine;
    getModelViewer.addEventListener("progress", (e) => {
      const getProgress = e.detail.totalProgress;
      setModelLoadingProgress(+getProgress.toFixed(2));
      if (!netStatus) {
        setModalSetting({
          ...modalSetting,
          coverSetting: true,
          otherBtnText: t("PleaseTryAgain"),
          noClose: true,
          handleOtherAction: true,
          iframe: true,
          type: "type37",
          handleConfirm: () => {
            window.location.reload();
          },
        });
        setShowModelErr(true);
      }
    });
  }, []);

  const acceptedFiles = (e) => {
    const files = Array.from(e);
    if (files.length === 0) return;
    packRequestId.current += 1;
    const requestId = packRequestId.current;
    const gltfOrZip = isGltfOrZipUpload(files);
    if (gltfOrZip) {
      // 選了 glTF / ZIP 就先清掉上一次選好的模型，而且放在容量檢查之前：不論後面是超限、打包失敗
      // 或檔名過長，舊模型都不會殘留成可上傳狀態。單檔 GLB / KSPLAT 路徑維持原本行為不動。
      setIsUpload(false);
      setFlieModel(null);
      setFileName("");
      setFileType("");
    }
    const totalMB = files.reduce((sum, f) => sum + f.size, 0) / (1024 * 1024);
    if (totalMB > MAX_UPLOAD_MB) {
      setModalSetting({
        ...modalSetting,
        show: true,
        type: "type14",
        otherBtnText: t("common.confirm"),
      });
      return;
    }
    // glTF 多檔（含 .bin / 貼圖）或 ZIP：先在瀏覽器端打包成單一 GLB，再走原本的 glb 上傳流程
    if (gltfOrZip) {
      prepareModelFile(files, { maxBytes: MAX_UPLOAD_MB * 1024 * 1024 })
        .then((result) => {
          if (requestId !== packRequestId.current) return; // 使用者已改選別的檔案
          if (!result) throw new Error("not a gltf/zip upload");
          const packed = new File([result.bytes], result.name, { type: "model/gltf-binary" });
          if (packed.name.length > MAX_FILE_NAME_LENGTH) {
            setModalSetting({
              ...modalSetting,
              show: true,
              type: "type42",
              otherBtnText: t("common.confirm"),
            });
            return;
          }
          setFileType("glb");
          setIsUpload(true);
          setFlieModel(packed);
          setFileName(packed.name);
        })
        .catch((err) => {
          if (requestId !== packRequestId.current) return; // 使用者已改選別的檔案
          console.error("glTF pack failed:", err);
          setModalSetting({
            ...modalSetting,
            show: true,
            type: PACK_ERROR_MODAL[err.code] || "type48",
            otherBtnText: t("common.confirm"),
          });
        });
      return;
    }
    if (e.length > 1) {
      setModalSetting({
        ...modalSetting,
        show: true,
        type: "type15",
        otherBtnText: t("common.confirm"),
      });
      return;
    } else if (!ACCEPTED_FILE_TYPES.some((ext) => e[0].name.includes(ext))) {
      setModalSetting({
        ...modalSetting,
        show: true,
        type: "type16",
        otherBtnText: t("common.confirm"),
      });
      return;
    } else if (e[0].name.length > 80) {
      setModalSetting({
        ...modalSetting,
        show: true,
        type: "type42",
        otherBtnText: t("common.confirm"),
      });
      return;
    }
    const matchedType = ACCEPTED_FILE_TYPES.find((type) => e[0].name.includes(type));
    if (matchedType) {
      setFileType(matchedType);
    }

    setIsUpload(true);
    setFlieModel(e[0]);
    setFileName(e[0].name);
  };

  const [modelFile, setModleFile] = useState("");
  const [pictureUrl, setPictureUrl] = useState("");

  function dataURLtoBlob(dataURL) {
    const [header, base64Data] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  }

  const startUploadEvent = (e) => {
    if (e) e.preventDefault();
    setStartUpload(true);
    if ((fileType === "splat" || fileType === "ksplat") && !loaderThreeJs) {
      setLoaderThreeJs(true);
      return;
    }

    let fileData = new FormData();
    fileData.append("file", fileModel);
    // 從編輯器(Editor)過來，上傳次物件
    if (otherModelTitle) {
      const handleUploadBar = (progress) => {
        if (progress > 96) {
          setUploadProgress(96);
        } else {
          setUploadProgress(progress);
        }
      };
      modelUpload(
        fileData,
        Cookies.get("token"),
        Cookies.get("projectId"),
        Cookies.get("modelId"),
        fileType,
        handleUploadBar,
      )
        .then((res) => {
          setModleFile(res.fileDownloadUri);
          modelViewer.current.addEventListener("progress", async (e) => {
            const getProgress = e.detail.totalProgress;
            if (getProgress === 1) {
              let formData = new FormData();
              const myFile = await modelViewer.current.toBlob();
              formData.append("file", myFile);
              formData.fileType = "image/png";
              projectPicture(
                formData,
                Cookies.get("projectId"),
                Cookies.get("modelId"),
                Cookies.get("token"),
              )
                .then((res) => {
                  const token = Cookies.get("token");
                  // encodeURIComponent
                  const encodeProjectId = encodeURIComponent(Cookies.get("projectId"));
                  const encodeModelsId = encodeURIComponent(Cookies.get("modelId"));
                  const encodeToken = encodeURIComponent(token);
                  const encodeisPublish = encodeURIComponent(Cookies.get("isPublish"));
                  const lang = Cookies.get("lang");
                  window.open(
                    `${SERVER.EDITOR_URL}?projectId=${encodeProjectId}&modelsId=${encodeModelsId}&token=${encodeToken}&isPublish=${encodeisPublish}&lang=${lang}`,
                    "_self",
                  );
                  setLoaderThreeJs(false);
                  setStartUpload(false);
                })
                .catch((err) => {
                  setLoaderThreeJs(false);
                  setStartUpload(false);
                  setIsUpload(false);
                  setFileName("");
                  handleErrorResponse("type22");
                });
            }
          });
        })
        .catch((err) => {
          handleErrorResponse("type22");
          setLoaderThreeJs(false);
          setStartUpload(false);
        });
    } else {
      // 進度條原本直接對應「bytes 送出」並在 96% 封頂，但 bytes 送完之後還有後端處理、
      // 把模型載進 model-viewer、產生縮圖、上傳縮圖等階段，使用者會看到 96% 長時間不動。
      // 這裡把上傳階段壓縮到 0-70%，剩下的 30% 留給後續階段依序推進。
      const handleUploadBar = (progress) => {
        setUploadProgress(Math.min(UPLOAD_BAR_SENT, Math.round(progress * 0.7)));
      };
      // 初始化模型屬性
      let initModel = {
        glbName: "",
        glbSrc: "",
        gltfName: "",
        gltfSrc: "",
        splatSrc: "",
        splatName: "",
        usdzName: "",
        usdzSrc: "",
        viewModeSwitch: true,
      };
      updateModel(
        initModel,
        Cookies.get("token"),
        Cookies.get("projectId"),
        Cookies.get("modelId"),
      );
      // 上傳模型(Gltf/Glb)
      modelUpload(
        fileData,
        Cookies.get("token"),
        Cookies.get("projectId"),
        Cookies.get("modelId"),
        fileType,
        handleUploadBar,
      )
        .then((res) => {
          setUploadProgress(UPLOAD_BAR_UPLOADED);
          let body = {
            description: "",
            hashTags: [],
            id: Cookies.get("projectId"),
            name: fileName,
          };
          // 修改專案
          reviseProject(body, Cookies.get("token"))
            .then(() => {
              // 縮圖改用使用者本機的那一份檔案產生，不必等它上傳完再從 CDN 整個下載回來。
              // 後端 uploadGlb 走 uploadModelResource → s3Client.putObject 原樣存檔、不做任何
              // 轉檔，所以本機檔案與 CDN 上的檔案逐 byte 相同，縮圖不會有落差。
              // splat / ksplat 的縮圖由 ThreeJs 元件產生、走不同流程，這裡維持原本行為不動。
              const canUseLocalFile = !!fileModel && fileType !== "splat" && fileType !== "ksplat";
              const localModelUrl = canUseLocalFile ? URL.createObjectURL(fileModel) : null;
              setModleFile(localModelUrl || res.fileDownloadUri);
              setUploadProgress(UPLOAD_BAR_LOADING);
              modelViewer.current.addEventListener("progress", async (e) => {
                const getProgress = e.detail.totalProgress;
                if (getProgress === 1) {
                  setUploadProgress(UPLOAD_BAR_RENDERED);
                  let formData = new FormData();
                  const myFile =
                    fileType === "splat" || fileType === "ksplat"
                      ? dataURLtoBlob(threeThumbnail)
                      : await modelViewer.current.toBlob();
                  if (localModelUrl) URL.revokeObjectURL(localModelUrl);
                  setUploadProgress(UPLOAD_BAR_THUMB);
                  formData.append("file", myFile);
                  formData.fileType = "image/png";
                  projectPicture(
                    formData,
                    Cookies.get("projectId"),
                    Cookies.get("modelId"),
                    Cookies.get("token"),
                  )
                    .then((res) => {
                      setUploadProgress(UPLOAD_BAR_DONE);
                      navigate({
                        pathname: "/projectInfo",
                        search: `?mode=create&fileName=${fileName}`,
                      }); //fileName
                      setLoaderThreeJs(false);
                      setStartUpload(false);
                      // 這裡原本在 navigate 之後馬上 location.reload()，是為了讓 /projectInfo
                      // 重新抓資料（它的 useEffect 依賴 []，同路由再 navigate 不會重跑）。
                      // 現在 ProjectInfo 已改成依賴網址參數，不需要再整頁重載。
                    })
                    .catch((err) => {
                      setLoaderThreeJs(false);
                      setStartUpload(false);
                      setIsUpload(false);
                      setFileName("");
                      handleErrorResponse("type22");
                    });
                }
              });
            })
            .catch((err) => {
              setLoaderThreeJs(false);
              setStartUpload(false);
              setIsUpload(false);
              setFileName("");
              handleErrorResponse("type22");
            });

          // navigate({
          //     pathname: '/projectInfo',
          //     search: `?mode=create&fileName=${fileName}`,
          // }); //fileName
        })
        .catch((err) => {
          setLoaderThreeJs(false);
          setStartUpload(false);
          setIsUpload(false);
          setFileName("");
          handleErrorResponse("type22");
        });
    }
  };

  useEffect(() => {
    if (threeThumbnail) {
      startUploadEvent();
    }
  }, [threeThumbnail]);

  const clearFileEvent = (e) => {
    e.preventDefault();
    setFlieModel(null);
    setStartUpload(false);
    setIsUpload(false);
    if (window.location.search === "") {
      deleteProject(Cookies.get("projectId"), Cookies.get("token")).then((res) => {
        navigate("/chooseType");
      });
    } else if (
      window.location.href.indexOf("/upload") > -1 &&
      window.location.href.indexOf("create=true") > -1 &&
      window.location.href.indexOf("useMaterialLab=true") > -1
    ) {
      // 第一次創建專案，預設進入素材庫，關閉時返回 CardList
      deleteProject(Cookies.get("projectId"), Cookies.get("token")).then((res) => {
        navigate("/chooseType");
      });
      return;
    } else if (window.location.href.indexOf("?fileName=") > -1) {
      history.back();
    } else if (window.location.search !== "") {
      deleteModel(Cookies.get("token"), Cookies.get("projectId"), Cookies.get("modelId")).then(
        () => {
          getProject(Cookies.get("token"), Cookies.get("projectId")).then((res) => {
            const token = Cookies.get("token");
            // encodeURIComponent
            const lang = encodeURIComponent(Cookies.get("lang"));
            const encodeProjectId = encodeURIComponent(Cookies.get("projectId"));
            const encodeModelsId = encodeURIComponent(res.project.editors[0].models[0].id);
            const encodeToken = encodeURIComponent(token);
            const encodeisPublish = encodeURIComponent(res.project.editors[0].publicSwitch);
            window.open(
              `${SERVER.EDITOR_URL}/?projectId=${encodeProjectId}&modelsId=${encodeModelsId}&token=${encodeToken}&isPublish=${encodeisPublish}&lang=${lang}`,
              "_self",
            );
          });
        },
      );
    }
  };

  const handleUploadOption = (e) => {
    setUploadOption(e);
  };

  const handleOpenIframe = (item) => {
    setMaterialIframe(item);
    setOpenIframe(true);
  };

  const handleCloseIframe = () => {
    setOpenIframe(false);
  };

  const handleUseMaterialLib = (item) => {
    if (
      urlParams.get("projectId") &&
      urlParams.get("modelId") &&
      urlParams.get("token") &&
      urlParams.get("isPublish")
    ) {
      useMaterialLib(
        Cookies.get("token"),
        item.id,
        Cookies.get("projectId"),
        Cookies.get("modelId"),
      )
        .then(() => {
          // 修改模型屬性 (viewModeSwitch)
          updateModel(
            { viewModeSwitch: true },
            Cookies.get("token"),
            Cookies.get("projectId"),
            Cookies.get("modelId"),
          );
        })
        .then(() => {
          const token = Cookies.get("token");
          // encodeURIComponent
          const encodeProjectId = encodeURIComponent(Cookies.get("projectId"));
          const encodeModelsId = encodeURIComponent(Cookies.get("modelId"));
          const encodeToken = encodeURIComponent(token);
          const encodeisPublish = encodeURIComponent(Cookies.get("isPublish"));
          const lang = Cookies.get("lang");
          window.open(
            `${SERVER.EDITOR_URL}?projectId=${encodeProjectId}&modelsId=${encodeModelsId}&token=${encodeToken}&isPublish=${encodeisPublish}&lang=${lang}`,
            "_self",
          );
        })
        .catch((err) => {
          handleErrorResponse("type22");
          setStartUpload(false);
        });
    } else {
      useMaterialLib(
        Cookies.get("token"),
        item.id,
        Cookies.get("projectId"),
        Cookies.get("modelId"),
      )
        .then(() => {
          // 修改模型屬性 (viewModeSwitch)
          updateModel(
            { viewModeSwitch: true },
            Cookies.get("token"),
            Cookies.get("projectId"),
            Cookies.get("modelId"),
          );
        })
        .then(() => {
          navigate({
            pathname: "/projectInfo",
            search: `?mode=create&fileName=${item.name}&useMaterialLab=true`,
          });
        })
        .catch((err) => {
          setStartUpload(false);
          setIsUpload(false);
          setFileName("");
          handleErrorResponse("type22");
        });
    }
  };

  const MaterialLibListholder = () => {
    let inner = [];
    for (let i = 0; i < 12; i++) {
      inner.push(
        <div className="materialLib_List_holder_Card" key={i}>
          <div className="materialLib_List_holder_Card_Pic"></div>
          <div className="materialLib_List_holder_Card_Name"></div>
        </div>,
      );
    }
    return inner;
  };

  const handleOpenNameTootip = (name) => (element) => {
    if (name.length > 30) {
      let X = element.target.getBoundingClientRect().left;
      let Y = element.target.getBoundingClientRect().top + window.pageYOffset;
      tootipbox.current.style.left = X + "px";
      tootipbox.current.style.top = Y + "px";
      setNameTootip(name);
      setOpenNameTootip(true);
    }
  };

  const handlecloseNameTootip = () => {
    setOpenNameTootip(false);
  };

  const updateThumbnail = (thumbnail) => {
    setThreeThumbnail(thumbnail);
  };

  return (
    <StyledUpload>
      {modalSetting.show && (
        <ModalPopup
          modalConfig={modalConfig[modalSetting.type]}
          setModalSetting={setModalSetting}
          modalSetting={modalSetting}
        />
      )}
      {!startUpload && (
        <TopBar
          title={t("uploadTitle")}
          isReload={Boolean(getFileName)}
          reloadTitle={getFileName}
          isOther={otherModelTitle}
          noColor={true}
        />
      )}
      {!startUpload && (
        <div className="uploadOption" style={{ top: Boolean(getFileName) ? "56px" : "0px" }}>
          <div className="uploadOption_container">
            <div
              className={UploadOption ? "selet selet_3D isActive" : "selet selet_3D"}
              onClick={() => handleUploadOption(true)}
            >
              <span>{t("uploadTitle")}</span>
            </div>
            <div
              className={
                !UploadOption ? "selet select_MaterialLib isActive" : "selet select_MaterialLib"
              }
              onClick={() => handleUploadOption(false)}
            >
              <span>{t("useMaterialLib")}</span>
            </div>
          </div>
        </div>
      )}
      {!UploadOption && (
        <div className="materialLib_List">
          {materialLib.map((item, idx) => {
            return (
              <div
                className="materialLib_Card"
                key={item.id}
                onClick={() => handleOpenIframe(item)}
              >
                <div className="materialLib_Card_Pic">
                  <div className="materialLib_Card_Pic_Mask">
                    <div
                      className="useMaterial"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUseMaterialLib(item);
                      }}
                    >
                      {t("useMaterialObject")}
                    </div>
                    <div className="previewMaterial" onClick={() => handleOpenIframe(item)}>
                      {t("preview")}
                    </div>
                  </div>
                  <img src={item.icom} alt="item-icon" />
                </div>
                <div
                  className="materialLib_Card_Name"
                  onMouseEnter={handleOpenNameTootip(item.name)}
                  onMouseOut={handlecloseNameTootip}
                >
                  {item.name}
                </div>
              </div>
            );
          })}
          <div
            className="tootipbox"
            ref={tootipbox}
            style={{ display: openNameTootip ? "block" : "none" }}
          >
            <div className="triangle"></div>
            <div className="tootip">{nameTootip}</div>
          </div>
        </div>
      )}
      {!UploadOption && openMaterialPicHolder && (
        <div className="materialLib_List_holder">
          <MaterialLibListholder />
        </div>
      )}
      <div className="materialLib_ifram" style={{ display: openIframe ? "block" : "none" }}>
        <div className="materialLib_ifram_popup">
          <div className="closeBtn" onClick={handleCloseIframe}>
            <img src={closeIcon} />
          </div>
          <div className="main">
            {showModelErr && (
              <ModalPopup
                modalConfig={modalConfig[modalSetting.type]}
                setModalSetting={setModalSetting}
                modalSetting={modalSetting}
              />
            )}
            {modelLoadingProgress < 1 && (
              <div className="loadingProgressContainer flexCenter flexY">
                <div className="progressText">iStaging</div>
                <div className="progressBarPanel">
                  <ProgressBar now={modelLoadingProgress} min={0} max={1} />
                </div>
              </div>
            )}
            <model-viewer
              id="myModelViewer"
              camera-controls
              src={materialIframe?.glbgltf}
            ></model-viewer>
          </div>
          <div className="name">{materialIframe?.name}</div>
          <div className="useMaterial" onClick={() => handleUseMaterialLib(materialIframe)}>
            {t("useMaterialObject")}
          </div>
          {materialIframe?.name.length > 30 && (
            <div className="tootipbox">
              <div className="triangle"></div>
              <div className="tootip">{materialIframe?.name}</div>
            </div>
          )}
        </div>
      </div>
      {UploadOption && (
        <div className="inner">
          <div className="block">
            {UploadOption && (
              <Dropzone onDrop={acceptedFiles}>
                {({ getRootProps, getInputProps }) => (
                  <section className="fileDropCon">
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <p className="fileDrop"></p>
                    </div>
                  </section>
                )}
              </Dropzone>
            )}
            {!startUpload && UploadOption && (
              <div>
                <div className="info">
                  <div className={isUpload ? "file" : "file noFile"}>
                    <img className="fileIcon" src={fileUploadIcon} alt="" loading="lazy" />
                    {isUpload && <div className="tt">{fileName}</div>}
                  </div>
                  <div className="title">{t("uploadDescription1")}</div>
                  <div className="word">
                    {t("uploadDescription2")}
                    <br />
                    <span>{t("uploadDescription3")}</span>
                  </div>
                </div>
                <div className="btnContainer">
                  <a href="#" onClick={clearFileEvent} className="canelBtn">
                    {t("cancel")}
                  </a>
                  <a
                    href="#"
                    onClick={startUploadEvent}
                    className={isUpload ? "uploadBtn" : "uploadBtn noFile"}
                  >
                    {t("uploadObject")}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {startUpload && <LoadingBar progress={UploadProgress} fileName={fileName} />}
      <model-viewer id="modelViewer" ref={modelViewer} src={modelFile}></model-viewer>
      {loaderThreeJs && (
        <ThreeJs fileModel={fileModel} fileType={fileType} onThumbnailReceived={updateThumbnail} />
      )}
    </StyledUpload>
  );
};

export default Upload;
